export default "__VITE_ASSET__BSx$ViAe__"